// extracted by mini-css-extract-plugin
export default {"root":"CustomNode_root__rj2Ky","expandIconWrapper":"CustomNode_expandIconWrapper__EHArE","isOpen":"CustomNode_isOpen__p+rFO","labelGridItem":"CustomNode_labelGridItem__vbc7Y"};